import { AbstractControl } from "@angular/forms";
import { DynamicItem } from "@shared/models/common.models";

export class EliteFormPageModel extends DynamicItem {
  title: string;
  eliteFormId: string;
  questions: PageGroupItem[];
  order: number;
  flowchartSectionId: string;
  minRows: number;
}


export class PageGroupItem {
  id: string;
  parentId: string;
  type: 'Question' | 'Note' | 'Image' | 'Group';
  row: number;
  rowSpan: number;
  column: number;
  columnSpan: number;
  questions: PageGroupItem[];
  visibilityLogic: any;
  metaData: { [key: string]: any };
  parentQuestionId: string;
  parentFlowSectionId: string;
  validators: EliteFormValidators[]
}
export interface EliteFormValidators {
  key: string;
  title: string;
  message: string;
  regex: string;
  errorKey: string;
}

export const EliteFormGeneralNodes = [
  {
    id: '',
    title: 'Title',
    description: 'Add a title to your page',
    utility: '',
    order: 1,
    frozen: false,
    instruction: '',
    cellEditor: '',
    cellViewer: '',
    children: [],
    configKey: '',
    dataType: 'Title',
    fieldValues: {
      'EliteFormEditor': 'EliteFormTitleViewerComponent',
      'Icon': 'fa-regular fa-heading'
    },
    formulaField: '',
    isCustom: true,
    isMandatory: false,
    isReadOnly: false,
    metaData: {},
    options: [],
    questionId: ''
  },
  {
    id: '',
    title: 'Description',
    description: 'Add a description to your page',
    utility: '',
    order: 2,
    frozen: false,
    instruction: '',
    cellEditor: '',
    cellViewer: '',
    children: [],
    configKey: '',
    dataType: 'Description',
    fieldValues: {
      'EliteFormEditor': 'EliteFormDescriptionViewerComponent',
      'Icon': 'fa-regular fa-align-left'
    },
    formulaField: '',
    isCustom: true,
    isMandatory: false,
    isReadOnly: false,
    metaData: {},
    options: [],
    questionId: '',
  },
  {
    id: 'Add_page',
    title: 'Page',
    description: 'Add a page to your form',
    utility: '',
    order: 3,
    frozen: false,
    instruction: '',
    cellEditor: '',
    cellViewer: '',
    children: [],
    configKey: '',
    dataType: 'Title',
    fieldValues: {
      'EliteFormEditor': 'EliteFormTitleViewerComponent',
      'Icon': 'fa-regular fa-page'
    },
    formulaField: '',
    isCustom: true,
    isMandatory: false,
    isReadOnly: false,
    metaData: {},
    options: [],
    questionId: ''
  }
];



export interface FormFieldValueChangeEvent {
  fieldKey: string;
  fieldValue: string;
  fieldControl: AbstractControl<any, any>
  [key: string]: any;
}


export interface FlowchartQuestion {
  frozen: boolean;
  id: string;
  parentId: string;
  indentation: number;
  instruction: string;
  questionId: string;
  order: number;
  title: string;
  questionType: string;
  isMandatory: boolean;
  identityField: boolean;
  formulaField: string;
  dataTypeText: string;
  conditionDisplayText: string;
  visibilityLogicGate: VisibilityLogicGate;
  children: FlowchartQuestion[];
  isHidden: boolean;
  isParentHidden: boolean;
  isConditionalHidden: boolean;
  isHiddenByLogicGate: boolean;
  fieldKey: string;
  dataType: string;
  configKey: string;
  options: OptionItem[];
  cellEditor: string;
  cellViewer: string;
  isCustom: boolean;
  metaData: { [key: string]: string };
  fieldValues: { [key: string]: any };
  viewType: string;
  hasNotes: boolean;
  isReadOnly: boolean;
  canFilter: boolean;
}

export interface OptionItem {
  id: string;
  text: string;
  instruction: string;
  tags: string[];
  order: number;
  isCustom: boolean;
  thumbnails: string;
  isDisabled: boolean;
}

interface VisibilityLogicGate {
  visibilityType: string;
  displayText: string;
  toolTip: string;
}
